export default __webpack_public_path__ + "static/media/image4.cf667569.png";